/**
 * 剧集批量导入会话状态：ImportExcel 与 gather/index 共享，
 * 关闭导入弹窗后仍可显示进度条。
 */

const listeners = []

const state = {
  videoId: null,
  active: false,
  percent: 0,
  total: 0,
  success: 0,
  failed: 0,
  pending: 0,
  uploading: 0,
  message: ''
}

function notify() {
  const snap = { ...state }
  listeners.forEach(fn => {
    try {
      fn(snap)
    } catch (e) {
      // ignore
    }
  })
}

export function subscribeBatchSession(fn) {
  if (typeof fn === 'function') {
    listeners.push(fn)
    fn({ ...state })
  }
  return () => {
    const i = listeners.indexOf(fn)
    if (i >= 0) {
      listeners.splice(i, 1)
    }
  }
}

export function updateBatchSession(partial) {
  Object.assign(state, partial || {})
  notify()
}

export function clearBatchSession() {
  Object.assign(state, {
    videoId: null,
    active: false,
    percent: 0,
    total: 0,
    success: 0,
    failed: 0,
    pending: 0,
    uploading: 0,
    message: ''
  })
  notify()
}

export function getBatchSession() {
  return { ...state }
}
